// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"48":"e11b38df3dc71aef","80":"0767eedd8415bf34","260":"bb4d090c22da8c85","665":"b24eaeee4415b734"}[chunkId] + ".js";
};